import gql from "graphql-tag";

export const StarrableFieldsFragment = gql`
  fragment StarrableFields on Starrable {
    objectId
    stargazerCount
    viewerHasStarred
  }
`;
